export const MissingInputError = {message: 'Nicht alle notwendigen Informationen wurden ausgefüllt.'};
export const DetailMissingInputError = field => ({
  message: 'Nicht alle notwendigen Informationen wurden ausgefüllt.' + (field ? ` (${field})` : '')
});



// WEBPACK FOOTER //
// ./src/errors/InputErrors.js